import { render, staticRenderFns } from "./FillForm1CommonInfo.vue?vue&type=template&id=6b046485&scoped=true"
import script from "./FillForm1CommonInfo.vue?vue&type=script&lang=ts"
export * from "./FillForm1CommonInfo.vue?vue&type=script&lang=ts"
import style0 from "./FillForm1CommonInfo.vue?vue&type=style&index=0&id=6b046485&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b046485",
  null
  
)

export default component.exports